import React from "react";
import { Button, dialog, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import CardView from "../../components/common/CardView";
import Search from "../../components/Search";
import Table from "../../components/Table";
import withRouter from "../../withRouter";
import ServiceRequestLogPresenter from "./ServiceRequestLogPresenter";
import FormFactory from "../../components/FormFactory";
import FileUpload from "../../components/common/FileUpload";
import NavBar from "../../components/navigation";
import DateRangePicker from "../../components/common/DateRangePicker";

class ServiceRequestLogPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ServiceRequestLogPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getUser() {
    return this.getCurrentUser();
  }

  getCollectionName() {
    return "service_request_logs";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleViewObject(object) {
    const schme = this.getSchema(this.getCollectionName());
    console.log("VIEW: ", object);
    console.log("schema: ", schme);
    dialog.fire({
      html: (
        <div className="d-grid p-2">
          <h4>View Logs</h4>
          <hr />
          <FormFactory
            className="p-1"
            schema={schme}
            object={object}
            disabled
            excludeFields={[
              "id",
              "logDate",
              "updatedAt",
              "createdAt",
              "employee",
              "user",
              "retirveHandler",
              "selectedFiles",
              "acl",
              "request",
            ]}
          />
          <hr />
          <FileUpload
            disabled={true}
            label={"Upload Attachments"}
            attachments={object.selectedFiles}
          />
          <hr />
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    console.log("OBJECT: ", objects);
    const isMasterAdmin = this.getUser().roles.some(
      (role) => role.id === "Super Admin"
    )
      ? ""
      : "user";

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4 mt-5">
              <div
                className="d-flex mb-4 mt-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} {schema.label}
                </p>
              </div>

              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 mt-1 ">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-6 mt-1 border-box">
                    <DateRangePicker
                      fields={["createdAt", "updatedAt"]}
                      onFilter={(filterObj) => {
                        if (Object.keys(filterObj).length > 0) {
                          const updatedAtDate = new Date(
                            filterObj.updatedAt.$lte
                          );
                          updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                          const updatedFilterObj = {
                            ...filterObj,
                            updatedAt: {
                              $lte: updatedAtDate.toISOString().split("T")[0],
                            },
                          };
                          console.log("UPDTE: ", updatedFilterObj);
                          this.filterSubmit(updatedFilterObj);
                        } else {
                          this.filterSubmit(filterObj);
                        }
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      {/* <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GeneratePDF(objects)}
                      >
                        <i className="bi bi-filetype-pdf" /> PDF
                      </Button> */}
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel(objects)}
                      >
                        <i className="bi bi-filetype-exe" /> Excel
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel(objects)}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                objectData={this.handleViewObject.bind(this)}
                // refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", isMasterAdmin, "user"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ServiceRequestLogPage);
